import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-check-select-input',
    templateUrl: './check-select-input.component.html',
    styleUrls: ['./check-select-input.component.css'],
    standalone: false
})
export class CheckSelectInputComponent extends BaseFormInput {
}
